
















import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop } from 'vue-property-decorator';
import {
  BoxIcon,
  CalendarIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  FilterIcon,
  SearchIcon,
  UserIcon,
  XIcon,
} from 'vue-feather-icons';
import { DateFilter, IProduct } from 'admiral-core';
import 'dayjs/locale/de';
import Multiselect from 'vue-multiselect';
import { FilterMixin } from '@/mixins/FilterMixin';
import { mixins } from 'vue-class-component';
import ProductSelect from '@/components/common/selects/ProductSelect.vue';

@Component({
  name: 'product-filter',
  components: {
    ProductSelect,
    CalendarIcon,
    Multiselect,
    UserIcon,
    BoxIcon,
    SearchIcon,
    XIcon,
    FilterIcon,
    ChevronDownIcon,
    ChevronUpIcon,
  },
})
export default class ProductFilterComponent extends mixins(FilterMixin) {
  @Prop({ type: Array })
  selected!: IProduct[];

  @Prop({ type: String, default: () => '' })
  clazz!: string;

  @Prop({ type: String, default: () => '' })
  title!: string;

  updateProduct(val: IProduct | IProduct[]) {
    const product = val || [];

    this.$emit('update', Array.isArray(product) ? product : [product]);
  }

  get isDefault() {
    return this.selected.length === 0;
  }

  reset() {
    this.$emit('update', []);
  }
}
